import DocumentRepositoryList from "./pages/DocumentRepositoryList.vue";
export default { DocumentRepositoryList };
